// "use client";
// import React from "react";

// export default function HeroVideo() {
//   return (
//     <div className="relative w-screen h-screen overflow-hidden w-screen">

//       {/* Video */}
//       <video
//         src="https://www.pexels.com/download/video/2695085/?fps=29.97&h=720&w=1280"
//         className="absolute inset-0 w-full h-full object-cover grayscale"
//         loop
//         autoPlay
//         muted
//         playsInline
//         disablePictureInPicture
//         playbackRate={0.35}
//       />

//       {/* Gradient overlay */}
//       <div
//         className="absolute inset-0 z-0 pointer-events-none
//                    bg-gradient-to-b
//                    from-white/80 via-white/40 to-white/0
//                    dark:from-slate-900/80 dark:via-slate-900/40 dark:to-slate-900/0
//                    backdrop-brightness-90 backdrop-contrast-[1.6] backdrop-saturate-[1.4]"
//       />

//       {/* Grid overlay (TOP) */}
//       <div
//         className="absolute inset-1 z-50 pointer-events-none
//                    bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),
//                        linear-gradient(to_bottom,#80808012_1px,transparent_1px)]
//                    dark:bg-[linear-gradient(to_right,#1D293B_1px,transparent_1px),
//                             linear-gradient(to_bottom,#1D293B_1px,transparent_1px)]
//                    bg-[size:48px_64px] z-20"
//       />

//     </div>
//   );
// }



















"use client";
import React, { useContext, useEffect, useRef } from "react";
import { ScrollContext } from "@/providers/ScrollProvider";
export default function HeroVideo({videoSrc = 'https://www.pexels.com/download/video/2695085/?fps=29.97&h=720&w=1280'}) {
    // const videoRef = useRef(null);
    //   const { scrollingUp, scrollingDown, scrollY } = useContext(ScrollContext);
    //   console.log(scrollY)
    //     useEffect(() => {

    //     var video = document.getElementById("hero-video");

    //     // video.playbackRate = scrollY;

    //       if (videoRef.current) {
    //         videoRef.current.playbackRate = scrollY/100; // slower
    //         videoRef.current.style.marginTop=scrollY
    //       }
    //     }, [scrollY]);
  return (
    <>

    
      {/* Video background */}

      <div id="video-container" className="absolute top-18 left-0 w-screen h-screen z-[0] overflow-hidden">
        <video
  // ref={videoRef}
        id="hero-video"
          src={videoSrc}
          // src="https://www.pexels.com/download/video/11892851/?fps=24.0&h=720&w=1280"
          className="absolute top-0 left-0 w-full h-full object-cover grayscale"
          loop
          autoPlay
          muted
          playsInline
          disablePictureInPicture
          controlsList="nodownload nofullscreen noremoteplayback"
        />

        <div className="absolute inset-0 z-[0] pointer-events-none 
                        bg-gradient-to-b from-white via-white/80 to-white
                      dark:from-slate-950 dark:via-slate-900/70 dark:to-slate-950
                      backdrop-brightness-90 backdrop-contrast-[1.6] backdrop-saturate-[1.4]">
        </div>

              <div className="  
      w-screen absolute h-screen inset-0
      bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] 
dark:bg-[linear-gradient(to_right,#1D293B_1px,transparent_1px),linear-gradient(to_bottom,#1D293B_1px,transparent_1px)]
bg-[size:48px_64px] z-50">
      </div>
</div>
      {/* Page content */}

    </>
  );
}


















// "use client"
// import { useEffect, useRef } from "react";

// export default function HeroVideo() {
//   // const videoRef = useRef(null);

//   // useEffect(() => {

//   //       var video = document.getElementById("myVideo");

//   //       video.playbackRate = 0.1;

//   //   // if (videoRef.current) {
//   //   //   videoRef.current.playbackRate = 0.35; // slower
//   //   // }
//   // }, []);

//   return (
//     <div className={`video-container-light dark:video-container-dark`}>
//     <video
//       // ref={videoRef}
//       src="https://www.pexels.com/download/video/2695085/?fps=29.97&h=720&w=1280" // good
//       // src="https://www.pexels.com/download/video/8295518/?fps=60.0&h=720&w=1280" // trash
//       // src="https://www.pexels.com/download/video/11892851/?fps=24.0&h=720&w=1280"
//       id="myVideo"
//       className="min-w-[100vw] background-video z-0 shadow-2xl"
//       loop
//       autoPlay
//       muted
//       playsInline
//       disablePictureInPicture
//       playbackRate="0.35"
//       controlsList="nodownload nofullscreen noremoteplayback"
//     />
//     </div>
//   );
// }